import React, { useEffect, useMemo, useState } from "react";

const GaussAnimation = ({ isActive }) => {
  const [step, setStep] = useState(0);

  // Positionen
  const rows = [24, 42, 60, 78];
  const cols = [24, 42, 60, 78, 114];


  const order = useMemo(() => {
    const N = rows.length;
    const M = cols.length - 1;
    const ops = [];
    for (let c = 0; c < M; c++) {
      for (let r = c + 1; r < N; r++) {
        ops.push({ r, c });
      }
    }
    return ops;
  }, [rows, cols]);

  const vanishIndex = useMemo(() => {
    const map = new Map();
    order.forEach((op, i) => map.set(`${op.r},${op.c}`, i + 1));
    return map;
  }, [order]);

  useEffect(() => {
    if (!isActive || order.length === 0) {
      setStep(0);
      return;
    }
    const id = setInterval(() => {
      setStep((s) => (s + 1) % (order.length + 1));
    }, 1200);
    return () => clearInterval(id);
  }, [order.length, isActive]);

  const currentArrow = step >= 1 && step <= order.length ? order[step - 1] : null;

  const arrow = (fromY, toY) => (
    <g>
      <path d={`M142 ${fromY} H154 V ${toY} H142`} stroke="#f3f4f6" strokeWidth="2" fill="none" />
      <polygon points={`142,${toY} 146,${toY - 4} 146,${toY + 4}`} fill="#f3f4f6" />
    </g>
  );

  return (
    <div className="rounded-lg overflow-hidden">
      <svg
        viewBox="0 0 150 105"
        width="100%"
        height="100%"
        style={{ backgroundColor: "#2563eb" }}
        xmlns="http://www.w3.org/2000/svg"
      >

        <g transform="translate(4,0) scale(0.9)">

          <line x1="12" y1="12" x2="12" y2="96" stroke="#f3f4f6" strokeWidth="6" />
          <line x1="132" y1="12" x2="132" y2="96" stroke="#f3f4f6" strokeWidth="6" />
          <line x1="9" y1="12" x2="24" y2="12" stroke="#f3f4f6" strokeWidth="6" />
          <line x1="9" y1="96" x2="24" y2="96" stroke="#f3f4f6" strokeWidth="6" />
          <line x1="135" y1="12" x2="120" y2="12" stroke="#f3f4f6" strokeWidth="6" />
          <line x1="135" y1="96" x2="120" y2="96" stroke="#f3f4f6" strokeWidth="6" />


          <line x1="96" y1="20" x2="96" y2="88" stroke="#f3f4f6" strokeWidth="4" />


          {currentArrow && arrow(rows[currentArrow.c], rows[currentArrow.r])}


          {rows.map((y, r) =>
            cols.map((x, c) => {
              const key = `${r},${c}`;
              const vanishAt = vanishIndex.get(key);
              const isRHS = c === cols.length - 1;
              const isUpperOrDiag = c >= r;
              const hidden = !isRHS && !isUpperOrDiag && step >= (vanishAt ?? Infinity);

              return (
                <circle
                  key={key}
                  cx={x}
                  cy={y}
                  r="4.5"
                  fill="#f3f4f6"
                  className={hidden ? "opacity-0 transition-opacity duration-700" : "transition-opacity duration-700"}
                />
              );
            })
          )}
        </g>
      </svg>
    </div>
  );
};

export default GaussAnimation;
